/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// this is the calculator function     
function calculate(haspop,event){
       area = 0;
       area_append = 0;
      //console.log('haspop =', haspop);
      if (haspop == 'popup') {
		var par = $(event.currentTarget).parents('.len_wid');
        
        var len1 = par.find('[length_sq]').val() || 0;
        var len2 = par.find('[sub_length_sq]').val() || 0;
        
        var wid1 = par.find('[width_sq]').val() || 0;
        var wid2 = par.find('[sub_width_sq]').val() || 0;
        
        //var length = parseFloat(len1+'.'+len2 * 10 / 12);
        //var width = parseFloat(wid1+'.'+wid2 * 10 / 12);
        
        var length1 = parseInt(len1)*12 + parseInt(len2) * 1;
        var width1 = parseInt(wid1)*12 + parseInt(wid2) * 1
        
        var total_sq_feet = length1 * width1 / 144
        //console.log(total_sq_feet.toFixed(2));
        
        par.find('[total_line]').val(total_sq_feet.toFixed(2));
        
        $('[total_line]').each(function(){
          var tt = parseFloat($(this).val()) || 0;
          area = tt + area;
        });
         //console.log(area,' : area');         
      }else{
        area = parseFloat($('[subtotal_sq_pr]').val() || 0);
      }
      console.log('11 area =', area.toFixed(2));
      area = parseFloat(area.toFixed(2));
      var area1 = area.toString().split(".")[1];	
      var area2 = area.toString().split(".")[0];	
      if(area1 > 0){	
      	area_append = parseInt(area2, 10) + parseInt(1, 10);	
      }else{	
        area_append = area2	
      }
       
      //console.log('area =', area);
      $('[sub_total]').text(area+' sq. ft.');
      if (haspop == 'popup') {
        waste_p = parseFloat($('[waste_p]').val() || 0);
      }else{
        
        if($('[waste_check]'). prop("checked") == true){
          waste_p = 10;
        }else{
          waste_p = 0;
        }
        
      }
      var waste =  area * waste_p /100;
      waste = parseFloat(waste.toFixed(1));
      //console.log('waste =', waste);
      $('[waste]').text(waste+' sq. ft.');
      total = area + waste;
      console.log("area => "+ area + " waste => "+ waste);
      console.log("total => "+ total)
       //total = Math.round(total);
      total = parseFloat(total.toFixed(2));
      
      var n = total;	  	
      var total_num = n.toString().split(".")[1];	
      var total_num_first = n.toString().split(".")[0];	
      	
      if(total_num > 0)
      {
      	var c = parseInt(total_num_first, 10) + parseInt(1, 10);	
      }
  	  else
      {	
        var c = total_num_first	
      }	
  
      $('[total]').text(c+' sq. ft.');

       var box_sq = parseFloat($('.metavalue').attr('metavalue')) ;
      console.log("box_sq => " + box_sq)
       total_bx = Math.ceil(total / box_sq );
  
    	// total_bx = Math.round(total / box_sq );

       $('[total_bx]').text(total_bx);
       total_sq = total_bx * box_sq;
	  	setTimeout(function(){
          	var price_per_box = parseFloat($('.price-list').find('.price').attr('data-price') / 100);
  			var number_of_box = parseInt($('#total_bx_pr').html());
          	var new_update_price = price_per_box * number_of_box;
  			$('.calc-sub-calculator-form-ele').find('.estimated_total').html(new_update_price.toFixed(2));
  		
		},500);
  		
    }
// function closed here

    $('[waste_check]').on('change',function(){
      calculate('product_page');
       $('[cal_btn]').trigger('click');
    });
    
     $(document).on('keyup','[length_sq],[sub_length_sq],[width_sq],[sub_width_sq],[waste_p]',function(event){
     calculate('popup',event);
    });

    $('[subtotal_sq_pr]').keyup(function(event){
      var page_type = $('#page_type').val();  // page_type = 2(rolls) and page_type == 1(sqr feet cal)
      console.log("page_type => " + page_type);
      if(page_type == 1) {  //page_type == 1(sqr feet calculation)
         calculate('product_page');
      	 $('[cal_btn]').trigger('click');
      } else {
           var current_value = $('[subtotal_sq_pr]').val();
           current_value = Math.ceil(current_value);
           $('[subtotal_sq_pr]').val(current_value);
           roll_price_calculate(current_value,2);
         
      }
     
    });

    $('.cls_btn').on('click',function(){
      $('.main_cal').hide();
      $('body').css('overflow','auto');
    });

    $('[add_more]').on('click',function(){
      var html = $('[data_hide_div]').html();
      var last_in = parseInt($('.sec:last').attr('data-index')) + 1;
      $('[sq_ft_div]').append('<div class="sec" data-index="'+last_in+'"><h4>Section :'+last_in+' </h4><div class="len_wid">'+html+'<span class="ft_close"><i class="fa fa-close"></i></span></div></div>');
    });
    
    $('.how_cal_btn').on('click',function(){
      $('.main_cal').show();
      $('body').css('overflow','hidden');
    });

    $(document).on('click','.ft_close',function(){
      $(this).parents('.sec').remove();
      $('.sec').each(function(i){
        var ind = i + 1;
        $(this).attr('data-index',ind);
        $(this).find('h4').text('Section :'+ind);
      });
    });
    
    $('[cal_btn]').on('click',function(){
      
      $('[subtotal_sq_pr]').val(area_append);
      // $('.waste_pr_pr').text(waste_p);
      console.log("uvi")
      $('#total_bx_pr').text(total_bx);
      console.log("total_bx => " + total_bx);
      $('.total_sq_pr').text(total);
      
      $('[name="quantity"]').val(total_bx);
      
      //var current_var_id = parseFloat($('#ProductPrice-product-template').attr('data-price'));
      //var box_1 = parseFloat(current_var_id * total_bx);
      //$('.sq_pr').text('Box Total: $'+box_1.toFixed(2));

      $('.main_cal').hide();
      $('body').css('overflow','auto');
      
    });

    $('.see_more_con').on('click',function(){
      if($(this).attr('data-attr') == 'see_more'){
        $(this).attr('data-attr','see_less');
        $('.all_des').css({"height": "auto"});
        $(this).find('span').text('see Less')
      }else{
        $(this).attr('data-attr','see_more');
        $('.all_des').css({"height": "144px"});
        $(this).find('span').text('see More')
      }
      
    });
// function to calculate price 

function calculate_sqft_price(){
 	var price_per_box = parseFloat($('.price-list').find('.price').attr('data-price') / 100);
  	var sqft_per_unit = parseFloat($('#sqft_per_unit').attr('data-sqft'));
  	var rate_per_unit = price_per_box / sqft_per_unit;
}
calculate_sqft_price();

// Add remove box in product page.
$(document).ready(function(){
  	$(document).on('click','.add_box',function(e){
      e.preventDefault();
      
      var page_type = $('#page_type').val();  // page_type = 2(rolls) and page_type == 1(sqr feet cal)
     
      var before_update_value = parseInt($('[total_bx]').text());  
      var current_value = before_update_value + 1;
      
      if(page_type == 1) {  //page_type == 1(sqr feet calculation)
        
          var sqft_per_unit = parseFloat($('#sqft_per_unit').attr('data-sqft')) ;  
         
          if($('[waste_check]').is(":checked")){
                var get_ten_percent = (sqft_per_unit / 100) * 10;
          }else{
            var get_ten_percent = 0;
          }
          $('[subtotal_sq_pr]').val(current_value * sqft_per_unit + get_ten_percent);     
          $('[subtotal_sq_pr]').trigger('keyup');
        
      } else { // page_type = 2(rolls calculation)
      	  
          var roll_per_width = parseFloat($('#roll_per_width').attr('data-width')) ;  
          var tag_val = (roll_per_width/100) * current_value;
          console.log(tag_val);
          $('[subtotal_sq_pr]').val(tag_val);   
          roll_price_calculate(current_value,1);
          
      }
      
        
	});
  	
  	$(document).on('click','.sub_box',function(e){         
      e.preventDefault();
      
      var page_type = $('#page_type').val();  // page_type = 2(rolls) and page_type == 1(sqr feet cal)
      
      var before_update_value = parseInt($('[total_bx]').text());  
      var current_value = before_update_value - 1;
      
      if(page_type == 1) {  //page_type == 1(sqr feet calculation)
        
        if(before_update_value > 0){
          var sqft_per_unit = parseFloat($('#sqft_per_unit').attr('data-sqft')) ;  
         
          if($('[waste_check]').is(":checked")){
                var get_ten_percent = (sqft_per_unit / 100) * 10;
          }else{
            var get_ten_percent = 0;
          }
          $('[subtotal_sq_pr]').val(current_value * (sqft_per_unit - get_ten_percent));     
          $('[subtotal_sq_pr]').trigger('keyup');
        }
        
      } else { // page_type = 2(rolls calculation)
      	  
          if(before_update_value > 0){
            var roll_per_width = parseFloat($('#roll_per_width').attr('data-width')) ;   
            var current_value = before_update_value - 1;
            var tag_val = (roll_per_width/100) * current_value;
            $('[subtotal_sq_pr]').val(tag_val);     
            roll_price_calculate(current_value,1);
          }
      }
      
	});
  	$(document).on('keyup','.roll_quantity',function(e){       
  		var page_type = $('#page_type').val();  // page_type = 2(rolls) and page_type == 1(sqr feet cal)
      	var roll_per_width = parseFloat($('#roll_per_width').attr('data-width')) ; 
      	var current_value = parseInt($(this).val()); 
      	$('input[name="quantity"]').val(current_value);
      	var tag_val = (roll_per_width/100) * current_value;
      	$('[subtotal_sq_pr]').val(tag_val);     
      	roll_price_calculate(current_value,1);      
  	});
});


// this is the roll calculator function     
function roll_price_calculate(current_value,type){
  
    if(type == 2) {
      var roll_per_width = parseFloat($('#roll_per_width').attr('data-width')); 
      current_value = (current_value * 100) / roll_per_width;
      current_value = Math.ceil(current_value);
    } 
    
  	$('#total_bx_pr').text(current_value);
 	$('[total_bx]').text(current_value);
    var price_per_box = parseFloat($('.price-list').find('.price').attr('data-price') / 100);
    var new_update_price = price_per_box * current_value;
  	console.log(new_update_price);
  	$('.calc-sub-calculator-form-ele').find('.estimated_total').html(new_update_price.toFixed(2));
  		
}
var input = document.getElementById('address');
var autocomplete = new google.maps.places.Autocomplete(input);

$("#custom_tooltip").click(function () {
  if($(".custom_tooltiptext").css("visibility") == "hidden") { 
    $(".custom_tooltiptext").css("visibility", "visible");
  } else {
    $(".custom_tooltiptext").css("visibility", "hidden");
  }
});

